module.exports = __webpack_public_path__ + "img/b2.5a770e63.png";